import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const DegradationDetectionMock = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-gray-500/25 ring-1 ring-white/[0.04] font-mono" style={{ background: '#0f1923' }}>
    {/* Header bar */}
    <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/[0.06]" style={{ background: '#0c1520' }}>
      <div className="flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-wider text-gray-400 font-semibold">Health Monitor</span>
        <span className="text-[8px] text-gray-600">&middot; BTCUSDT &middot; 1d</span>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-center">
          <p className="text-[16px] font-bold text-amber-400 leading-none">4.2</p>
          <p className="text-[7px] uppercase tracking-wider text-gray-500">Health Score</p>
        </div>
        <span className="flex items-center gap-1 text-[8px] bg-amber-500/20 text-amber-300 px-1.5 py-0.5 rounded-full">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-[7px]" />
          Drift Detected
        </span>
      </div>
    </div>

    {/* Live Performance vs Expected */}
    <div className="mx-2 mt-2 rounded-lg border border-white/[0.06] p-3" style={{ background: '#181825' }}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-[9px] uppercase tracking-wider text-gray-400 font-semibold">Live Performance vs Expected</span>
        <span className="text-[9px] text-gray-500">Live Trades: <span className="text-white font-bold">47</span></span>
      </div>
      <div className="grid grid-cols-5 gap-1.5">
        {[
          { label: 'Win Rate', expected: '40.0%', range: '(40.0% - 40.0%)', actual: '28.3%', status: 'red' as const },
          { label: 'Sharpe Ratio', expected: '1.00', range: '(0.99 - 1.02)', actual: '0.41', status: 'red' as const },
          { label: 'Max Drawdown', expected: '21.9%', range: '(21.9% - 21.9%)', actual: '34.2%', status: 'red' as const },
          { label: 'Profit Factor', expected: '4.64', range: '(3.72 - 5.57)', actual: '1.12', status: 'amber' as const },
          { label: 'Avg Return/Trade', expected: '26.8%', range: '(26.6% - 27.1%)', actual: '8.1%', status: 'amber' as const },
        ].map((m) => (
          <div key={m.label} className={`rounded-lg p-2 ${m.status === 'red' ? 'bg-red-500/[0.06] border border-red-500/20' : 'bg-amber-500/[0.06] border border-amber-500/20'}`}>
            <p className="text-[7px] uppercase tracking-wider text-gray-500 mb-1">{m.label}</p>
            <p className="text-[13px] font-bold text-white">{m.expected} <span className="text-[8px] font-normal text-gray-500">{m.range}</span></p>
            <p className={`text-[9px] mt-0.5 font-medium ${m.status === 'red' ? 'text-red-400' : 'text-amber-400'}`}>Actual: {m.actual}</p>
          </div>
        ))}
      </div>
      <p className="text-[9px] text-amber-400 mt-2">
        <FontAwesomeIcon icon={faExclamationTriangle} className="mr-1 text-[8px]" />
        Performance drift exceeds tolerance -- re-validation recommended.
      </p>
    </div>

    {/* Drift Signals */}
    <div className="mx-2 mt-2 mb-2 rounded-lg border border-white/[0.06] p-3" style={{ background: '#181825' }}>
      <span className="text-[9px] uppercase tracking-wider text-gray-400 font-semibold block mb-2">Drift Signals</span>
      <div className="space-y-1.5">
        {[
          { signal: 'Return distribution drift', severity: 'High', color: 'text-red-400', bg: 'bg-red-500/20' },
          { signal: 'Drawdown behaviour drift', severity: 'High', color: 'text-red-400', bg: 'bg-red-500/20' },
          { signal: 'Signal frequency drift', severity: 'Moderate', color: 'text-amber-400', bg: 'bg-amber-500/20' },
          { signal: 'Parameter region stability', severity: 'Low', color: 'text-emerald-400', bg: 'bg-emerald-500/20' },
        ].map((d) => (
          <div key={d.signal} className="flex items-center justify-between">
            <span className="text-[9px] text-gray-400">{d.signal}</span>
            <span className={`text-[8px] ${d.color} ${d.bg} px-1.5 py-0.5 rounded-full font-medium`}>{d.severity}</span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between mt-3 pt-2 border-t border-white/[0.06] text-[9px]">
        <span className="text-gray-500">Recommendation:</span>
        <span className="text-amber-400 font-semibold">Re-validate strategy</span>
      </div>
    </div>
  </div>
);

export default DegradationDetectionMock;
